import uncoverPassword from '../js/uncover_password.js'
window.uncoverPassword = uncoverPassword